import SchedulingEnrollCourseForm from './Form'

export default function SchedulingEnrollCourseFormIndex({ selectedCourseSession, setSelectedCourseSession }) {
  return <SchedulingEnrollCourseForm selectedCourseSession={selectedCourseSession} setSelectedCourseSession={setSelectedCourseSession} />
}
